const changelog = [
  {
    date: '2026-10-24',
    changes: [
      '✅ 시오사 페이지 추가 - POE1 액트 진행 도우미 프로그램 "시오사" 다운로드 및 사용법 안내',
      '✅ 갑충석 시세 - 인게임 갑충석 창고와 같은 배치로 보는 "창고형" 보기 추가 ( 칸에서 바로 시세 확인, 클릭하면 정규식에 추가 )',
      '✅ 마석학 가루 - 포이닌자 시세, 매물 수, 1c당 가루(가성비) 항목 추가',
      '🔨 딸깍 시뮬레이터 리뉴얼 - 인게임 푸르미 제작처럼 인벤토리 → 슬롯 → 제작하기 방식으로 변경, 카드 시세로 구매/판매, 행운아·불운아 랭킹 TOP 5',
      '　　- 랭킹 등록은 하루 1회, 등록하면 자동으로 리셋됩니다.',
      '✅ 문의 안내 추가 - 하단에 문의 이메일, 버그 제보 페이지에 카카오톡 오픈채팅 링크와 QR 코드 추가',
    ]
  },
  {
    date: '2026-09-15',
    changes: [
      '🔨 POE1 시세 필터 - 최소값 또는 최대값만 입력해도 정규식 조회 가능하도록 변경',
      '🔨 POE2 서판 정규식 업데이트 - 0.5.5v 탐험 서판 정규식 업데이트',
    ]
  },
  {
    date: '2026-08-31',
    changes: [
      '✅ 웹사이트 디자인 리뉴얼',
      '✅ 지도, 경로석, 서판 정규식 공유 및 불러오기 기능 추가',
      '✅ POE2 정규식 업데이트',
      '✅ POE2 서판 정규식 추가',
      '🛠 저장 목록 불러오기 오류 수정 - 수량, 규모 및 수치 관련 데이터가 불러와지지 않던 현상 수정 ( 이후 새롭게 저장한 데이터부터 정상 작동됩니다. )'
    ]
  },
  {
    date: '2026-08-18',
    changes: [
      '🛠 수량, 규모 정규식 수정 - 타락 옵션도 같이 필터링 되던 현상 수정',
    ]
  },
  {
    date: '2026-08-14',
    changes: [
      '✅ 야수 시세 페이지 - 야수 시세 및 정규식 페이지 추가',
    ]
  },
  {
    date: '2026-08-11',
    changes: [
      '✅ 도전과제 업데이트 - 3.29 도전과제 세부 공략 추가',
    ]
  },
  {
    date: '2026-08-07',
    changes: [
      '🛠 갑충석 정규식 - 군중의 심연 갑충석, 선택의 의식 갑충석, 결투의 결전 갑충석, 보물의 거대한 갑충석, 전설의 거대한 갑충석 정규식 수정',
    ]
  },
  {
    date: '2026-08-06',
    changes: [
      '🛠 수량 정규식 - n0이상으로 설정 시 쇠약화 저주 맵모드가 걸리는 현상 수정 ( 쇠약화 설명에 만족했던 현상 )',
      '　　"량.*" -> "수량.*" 으로 변경',
    ]
  },
  {
    date: '2026-08-04',
    changes: [
      '✅ 도전과제 업데이트 - 3.29 도전과제 갱신 및 공략이 특별하게 필요 없는 목록은 제거',
    ]
  },
  {
    date: '2026-08-03',
    changes: [
      '⚠️ 무리규모 정규식 - 몬스터 무리 규모 정규식이 안되던 현상 수정',
    ]
  },
  {
    date: '2026-08-01 정규식 수정 내역',
    changes: [
      '※ 기존에 저장해두신 정규식은 삭제하시고 다시 만드시는것을 추천드립니다!',
      '※ 일반 맵모드와 악몽 맵모드가 겹치는 대부분의 정규식들은 따로 작동되도록 변경되었습니다.',
      '　　- 모드가 같더라도 각각 선택해서 둘다 정규식에 포함시켜야 완벽하게 걸러집니다.',
      '　　- 수치가 높은 악몽 맵모드만 거르는게 가능해졌습니다.',
      '※ 지도 각각 1쿼드씩 테스트 했지만 표본이 적어 오류가 있을 수 있습니다. 제보 부탁드립니다!'
    ]
  },
  {
    date: '지도 이름과 겹치는 정규식들',
    changes: [
      '"서로 가까이 있는 적을 처치하면 이계 몬스터를 불러옴"',
      '"지역에 악마 서식"',
      '"지역에 훼손된 지대 존재"',
      '"지역 내 희귀 몬스터가 쉐이퍼의 손길에 닿음"'
    ]
  },
  
  {
    date: '잘못된 정규식들',
    changes: [
      '"지역에 등장하는 몬스터 종류 증가" - 다른 모드와 중복',
      '"지역에 질식의 구체 등장" - 다른 모드와 중복',
      '"17T 저주3종 세트" - 다른 모드와 중복',
      '"몬스터의 카오스 저항 +25%"이 "몬스터의 공격 명중 시 중독"에 걸림',
      '"몬스터가 공격 시 60%의 확률로 꿰뚫음"이 "몬스터 피해가 15%의 원소 저항 관통"에 걸림',
      '"고유 보스가 사로잡힘"이 "몬스터가 명중 시 탐욕스러운 덩굴 2개 유발"에 걸림',
      '"몬스터가 치명타로 받는 추가 피해 (36-40)% 감소"가 "흡수로 인한 플레이어의 초당 총 생명력, 마나, 에너지 보호막 회복량 최대치가 (50-60)% 감소"에 걸림',
      '"플레이어가 노출 유발 불가"가 "플레이어의 모든 저항 최대치 (-12--9)%"에 걸림',
      '"지역에 #%만큼 피해가 증가한 감전 지대 존재"가 "플레이어가 시간의 사슬 저주에 걸림"에 걸림',
      '"동료에게 영향을 주는 플레이어의 오라 스킬이 적에게도 영향을 줌"이 "몬스터가 공격 시 60%의 확률로 꿰뚫음"에 걸림',
    ]
  },
  {
    date: '일반 지도와 악몽 지도 모드가 겹치는 부분(이제 각각 따로 적용됩니다.)',
    changes: [
      '"몬스터의 주문 피해 억제 확률"',
      '"몬스터의 물리 피해 감소"',
      '"몬스터의 생명력 #% 증폭"',
      '"몬스터 피해 #% 증가"',
      '"몬스터가 최대 생명력의 #%를 추가 에너지 보호막 최대치로 획득"',
      '"몬스터의 스킬 2회 추가 연쇄"',
      '"희귀 몬스터 수 (20-30)% 증가"',
      '"희귀 몬스터가 물리 가시를 보유하고 #의 물리 피해 반사"',
      '"희귀 몬스터가 원소 가시를 보유하고 #의 원소 피해 반사"',
      '"몬스터의 치명타 확률 #% 증가"',
      '"플레이어에게 적용되는 버프가 70% 더 빠르게 만료됨"',
      '"몬스터 기절 면역"',
      '"몬스터가 투사체 2개 추가 발사"',
      '"몬스터가 물리 피해의 #%를 추가 카오스 피해로 획득"'
    ]
  },
  {
    date: '맵 모드 변경',
    changes: [
      '"몬스터가 명중 시 20%의 확률로 원소 상태 이상 유발" -> "몬스터가 명중 시 20%의 확률로 점화, 동결, 감전 유발"',
      '"지역에 탈주 유배자 추가 2명이 서식" -> 삭제'
    ]
  },
  {
    date: '노답 - 일반과 악몽 맵모드가 완전히 일치함',
    changes: [
      '"몬스터가 치명타로 받는 추가 피해 (36-40)% 감소" - 수치 범위가 겹침',
      '"플레이어의 효과 범위 25% 감폭"',
      '"플레이어가 원소 약화 저주에 걸림"',
      '"플레이어가 취약성 저주에 걸림"',
      '"플레이어가 시간의 사슬 저주에 걸림"',
      '"몬스터가 명중 시 격분 충전 획득"',
      '"몬스터가 명중 시 인내 충전 획득"',
      '"몬스터가 명중 시 권능 충전 획득"',
      '"고유 보스가 사로잡힘"',
      '"몬스터의 이동, 공격, 시전 속도 증가"'
    ]
  },
  {
    date: '2026-08-01',
    changes: [
      '✅ 마석학 가루 페이지 추가 - 템렙 84 기준 분해시 얻는 마석학 가루 수량 페이지 추가',
      '🛠 맵모드 정규식 - 플레이어의 방어도 30% 감폭\n플레이어의 막기 확률 40% 감소 정규식 수정',
      '🛠 딸깍 시뮬 데이터 리셋 ( 곧 페이지 삭제 예정 )',
      '❌ 애드센스 광고 삭제'
    ]
  },
  {
    date: '2026-07-31',
    changes: [
      '🛠 맵모드 정규식 - 지역에 작열하는 총주교의 룬 등장" 정규식 수정',
      '🛠 맵모드 정규식 - "몬스터가 사술 방지 보유" 정규식 수정',
    ]
  },
  {
    date: '2026-07-30',
    changes: [
      '✅ 결전 정규식 추가 - 결전(Ultimatum) 정규식 페이지 추가',
      '✅ 항해 정규식 추가 - 항해(Voyage) 정규식 페이지 추가',
      '🛠 맵모드 정규식 - \'몬스터가 50%의 확률로 중독, 꿰뚫기, 출혈 회피\' 정규식 수정',
      '🛠 맵모드 정규식 - 반사 삭제, 가시 추가(기존 정규식과 동일)',
      '※ 이전 버전 저장된 정규식에 반사 그대로 사용하면 가시 맵모드가 포함됩니다',
    ]
  },
  {
    date: '2026-07-26',
    changes: [
      '🛠 시세 - 3.29 리그 데이터로 반영',
    ]
  },
  {
    date: '2026-07-24',
    changes: [
      '🛠 시세 탭 통합 - 갑충석, 성유, 문신, 룬 시세 탭 통합',
      '🛠 버그 제보글 수정 삭제 추가',
      '❌ 아틀라스 페이지 삭제'
    ]
  },
  {
    date: '2026-04-10',
    changes: [
      '🛠 정규식 오류 수정 - 선택 시 여러개 선택되던 현상 수정',
      '🛠 정규식 오류 수정 - \'플레이어가 비-저주 오라 스킬로 받는 효과 60% 감소\' 정규식이 \'동료에게 영향을 주는 플레이어의 오라 스킬이 적에게도 영향을 줌\' 모드에도 겹치는 문제 수정',
    ]
  },
  {
    date: '2026-04-03',
    changes: [
      '🛠 정규식 오류 수정 - 16T 투사체 추가발사 모드 정규식 오류 수정',
      '🛠 정규식 저장 목록 불러오기 수정 - 저장 목록 불러오기 시 선택된 모드 없이 불러오는 문제 수정',
    ]
  },
  {
    date: '2026-03-30',
    changes: [
      '✅ 정규식 금액대별 조회 기능 - 카오스 가격 범위 별 정규식 조회 기능 추가',
    ]
  },
  {
    date: '2026-03-23',
    changes: [
      '✅ 도전과제 페이지 추가 - 도전과제(40챌) 공략 페이지 추가',
    ]
  },
  {
    date: '2026-03-21',
    changes: [
      '🛠 맵모드 정규식 - 저항최대치 -9~-12 와 -20 정규식 구분되도록 변경',
    ]
  },
  {
    date: '2026-03-17',
    changes: [
      '🛠 맵모드 정규식 - 플라스크 효과 감폭 정규식 수정',
    ]
  },
  {
    date: '2026-03-14',
    changes: [
      '✅ 저장목록 기능 추가 - 한글/영문 보기 옵션, 저장목록을 검색페이지로 불러오기 기능 추가',
      '🛠 맵모드 정규식 - 악몽지도 누락된 접두어 맵모드 추가( 미궁, 플라스크 효과 )'
    ]
  },
  {
    date: '2026-03-11',
    changes: [
      '🛠 갑충석 정규식 - 일부 갑충석 정규식 미반영 문제 수정',
    ]
  },
  {
    date: '2026-03-09',
    changes: [
      '✅ 3.28 정규식 추가 및 수정',
      '✅ 아틀라스 패시브 트리 페이지 추가',
      '🛠 시세데이터 - 허상 리그로 적용',
    ]
  },
  {
    date: '2026-03-04',
    changes: [
      '❌ 맵모드 삭제 - 3.28에서 삭제되는 맵모드 삭제',
      '🛠 정규식 오류 수정 - 꼭대기 지도와 재사용 대기 중복현상 수정',
    ]
  },
  {
    date: '2025-11-24',
    changes: [
      '🛠 정규식 오류 수정 - 올플레임 배신갑충석 정규식 추가, 증대의 지도 제작 갑충석 정규식 수정',
    ]
  },
  {
    date: '2025-11-09',
    changes: [
      '🛠 정규식 오류 수정 - 도깨비불의 갑충석 정규식 결과 중복되는 부분 수정',
    ]
  },
  {
    date: '2025-11-05',
    changes: [
      '🛠 정규식 오류 수정 - 물리반사와 꿰뚫기, 흡수 불가와 흡수 감소 중복되는 부분 해결',
      '✅ 지도 수량 정규식 추가',
      '🛠 수량관련 정규식 로직 변경 ( 300이상 안되던 문제 수정 )',
    ]
  },
  {
    date: '2025-11-02',
    changes: [
      '🛠 시세 탭 수호자들 리그로 변경',
    ]
  },
  {
    date: '2025-10-29',
    changes: [
      '🛠 정규식 변환기 처리 로직 변경',
      '🛠 맵모드 변경사항 수정',
    ]
  },
  {
    date: '2025-10-28',
    changes: [
      '✅ 버그제보 페이지 추가',
      '🛠 17T 맵모드별 옵션 추가',
      '🛠 17T 폰트 색상 변경',
      '🛠 수량 규모 정규식 정규식 오류 수정',
      '🛠 POE2 용암지대 -> 점화지대 수정',
    ]
  },
  {
    date: '2025-07-15',
    changes: [
      '🛠 17T 방어력 감폭 정규식 오류 수정',
    ]
  },
  {
    date: '2025-06-15',
    changes: [
      '🛠 딸깍 DB 초기화',
      '🛠 갑충석, 문신, 룬, 성유 시세 용병 리그로 적용',
    ]
  },
  {
    date: '2025-06-11',
    changes: [
      '🛠 정규식 최대 길이 250자로 수정',
      '✅ 문신, 룬, 성유 시세 페이지 추가',
    ]
  },
  {
    date: '2025-05-30',
    changes: [
      '❌ POE2 거래소 검색 및 저장 페이지 삭제',
      '❌ POE1 킹스마치 페이지 삭제',
      '🛠 POE1 한글처리 안된 17T 정규식 수정 ( 흡수로 인한 플레이어 회복량 감소)',
      '✅ 갑충석 시세 및 정규식 페이지 추가'
    ]
  },
];

export default changelog;

